import variables from '@/style/variables.scss'
import path from 'path'
import { setSession, getSession } from "@/utils/auth";
import { DateDifference, dateFormat1 } from "@/utils/tool";
import { resetRouter } from "@/router";


export default {
  name: "headerNav",
  data() {
    return {
      shopCode: '',
      options: [],
      accessRoutes: [],
      changeMenu: false,
      menu: true,
      adminFlag: '',
      formMenu: {
        data: 1
      },
      showEndDate: '',
      showReOrder: false
      // username: this.$store.getters.name,
    }
  },

  computed: {
    menusList() {
      return this.$store.state.user.plat
    },
    activeMenu() {
      const route = this.$route
      return route.matched[0].path || '/'
    },
    menuList() {
      let list = []
      //将菜单中没有隐藏的项渲染
      list = this.$store.getters.routes.filter((item, index) => {
        return !item.hidden
      })
      this.list = list
      //如果菜单列表存在时,执行菜单设置
      if (list && list.length != 0) {
        this.setCurMenu()
      }

      return list
    },
    variables() {
      return variables
    },
    shopList() {
      let shop = []
      if (typeof this.$store.getters.stores == 'string') {
        shop = JSON.parse(this.$store.getters.stores)
      } else {
        shop = this.$store.getters.stores
      }
      this.shopCode = this.$store.getters.shopCode
      return shop
    },
    username() {
      let name = this.$store.getters.name
      return name
    }
  },

  methods: {
    jumpOut() {
      window.open(`https://kdocs.cn/l/ckDRTjXyd7Dw`, '_blank')
    },
    async queryDeadDateBySellerId() {
      this.showEndDate = ''
      let res = await api.queryDeadDateBySellerId()
      this.showReOrder = false

      if (res.data.data) {
        let arr = res.data.data.sellerIdDeadDateDataVOList
        let startTime = dateFormat1('yyyy-MM-dd', new Date())
        if (arr.length === 1) {
          let endTime = DateDifference(startTime, arr[0].deadLineDate)
          if (endTime <= 30 && endTime > 0) {
            this.showEndDate = `${arr[0].channle}渠道授权仅剩` + endTime + '天！'
            this.showReOrder = true
          }
        }

        if (arr.length > 1) {
          let startTime = dateFormat1('yyyy-MM-dd', new Date())
          // let endTime2 = DateDifference(startTime,  '')
          let endTime = DateDifference(startTime, arr[0].deadLineDate)
          let endTime1 = DateDifference(startTime, arr[1].deadLineDate)

          if (endTime <= 30 && endTime < endTime1 && endTime > 0) {

            this.showEndDate = `${res.data.data[0].channle}渠道授权仅剩` + endTime + '天！'
            this.showReOrder = true
          }

          if (endTime1 <= 30 && endTime > endTime1 && endTime1 > 0) {

            this.showEndDate = `${res.data.data[1].channle}渠道授权仅剩` + endTime1 + '天'
            this.showReOrder = true
          }
          if (endTime == endTime1 && endTime <= 30 && endTime1 <= 30 && endTime > 0) {
            this.showEndDate = '授权仅剩' + endTime1 + '天！'
            this.showReOrder = true
          }

          if (endTime == endTime1 && endTime <= 0 && endTime1 <= 0) {
            this.showEndDate = '授权已失效！'
            this.showReOrder = true
          }
          if (endTime <= 0 && endTime1 > 0) {
            this.showEndDate = `${res.data.data[0].channle}渠道授权已失效！`
            this.showReOrder = true
          }
          if (endTime1 <= 0 && endTime > 0) {
            this.showEndDate = `${res.data.data[1].channle}渠道授权已失效！`
            this.showReOrder = true
          }
        }
        console.log('res111111111', this.showReOrder, this.showEndDate)
      }
      // this.authorizeDate = res.data.data
      // getDaysBetween()
      // // 2023-06-24
      // let date =dateFormat(new Date()) 
      // console.log(date)
    },

    cutPlat: async function (val) {

      setSession('plat', val)

      try {
        //获取用户权限
        const roles = await this.$store.dispatch('user/getMenu')

        const accessRoutes = await this.$store.dispatch('permission/generateRoutes', roles)

        //获取店铺
        const shops = await this.$store.dispatch('user/getShop', 'cut')
        // console.log(accessRoutes,'accessRoutes----')
        //每次添加路由前初始化路由状态
        resetRouter()
        this.$router.addRoutes(accessRoutes)

        this.accessRoutes = accessRoutes
        if (this.$router.resolve({ path: accessRoutes[0].path }).route.matched.path !== '/404' && this.$router.resolve({ path: accessRoutes[0].path }).route.matched.length !== 0) {
          this.$router.replace({ path: accessRoutes[0].path })
          //重新渲染头部
          this.menu = false
          this.$nextTick(() => {
            this.menu = true
          })
        }
        // setTimeout(()=>{
        //     this.$router.go(0);
        // },1000)


      } catch (e) {
        console.log(e)
      }
    },

    // 查询当前用户是否为MA系统管理员
    checkUserIsAdmin: function () {
      api.checkUserIsAdmin().then((res) => {
        if (res.data.code === 200) {
          this.adminFlag = res.data.data.adminFlag
        }
      })
    },
    setCurMenu: function () {
      let val = {}
      //如果页面没有默认一级菜单,默认显示第一个,存在的情况下为刷新页面时
      if (this.$route.path == '/') {
        let curPath = this.list.find(item => {
          return item.children.length > 0
        })
        this.$router.replace({
          path: curPath.path
        })
        // console.log(curPath,'curPath---')
        val = this.list[0]
      } else {
        val = this.$route.matched[0]
      }
      //如果菜单下存在子菜单,加载子菜单
      if (val.meta.hasChildrenMenu) {
        this.setLeftMenu(val)
      }
    },
    setLeftMenu: function (val) {

      //一级菜单路径
      let basePath = val.path;
      // console.log('this.list', this.list)
      let item = this.list.find((value, index) => {
        return value.path == basePath
      })
      if (item === undefined) return false
      let list = item.children.filter((value, index) => {
        return !value.hidden
      })
      // console.log(list,'listlistlist')
      this.$store.dispatch('leftMenu/changeLeftMenu', list)
      this.$store.dispatch('leftMenu/changeBasePath', basePath)
      //菜单切换时,如果当前没有选中菜单,默认第一个子菜单显示
      //matched的长度为1时表示是切换菜单进入,不为1时表示刷新进入,此时存在菜单项,不进行默认选中
      // console.log('this.$route', this.$route)
      if (this.$route.matched.length == 1) {
        // console.log(list)
        let rooPath = '/' + (list[0].children && list[0].children.length > 0 ? list[0].children[0].path : '')
        let toPath = path.resolve(basePath, (list[0].path + rooPath))
        // this.getPV(list[0].menuId)
        this.$router.replace({
          path: toPath
        })
      } else {
        // console.log(2222)
        // if (this.$route.params.source && this.$route.params.source == 'tab') return
        // let menuId = this.$route.meta.menuId || this.$route.matched[this.$route.matched.length - 2].meta.menuId
        // this.getPV(menuId)
      }
    },
    selectMenu: function (index) {
      this.$store.dispatch('navTab/setNavTab', { type: 'reset', base: index })
      if (this.activeMenu == index) {
        this.contentReload()
      }
    },
    //切换店铺
    changeShopcode: function (value) {
      this.queryDeadDateBySellerId()
      setSession('shopCode', value)
      let obj = this.shopList.find(item => item.sellerId === value)
      setSession('shopName', obj.shopName)
      this.$store.dispatch('user/changeShopCode', value)
      this.$store.dispatch('user/resetRoles')
      // 重置
      this.$store.dispatch('navTab/closeAllTab')

    },
    //退出登录
    exitSys() {
      this.$confirm('确定退出系统？', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.$store.dispatch('user/logout')
        location.href = process.env.VUE_APP_BASE_LOGIN
      }).catch(() => {

      });
    },
    //数据埋点
    getPV: function (menuId) {
      let params = {
        menuId: menuId,
        referer: document.domain,
      }
      api.addOverviewSystemLoginLogs(params).then(res => {
      })
    },

    verifyPlat: function () {
      let plat = getSession('plat')

      if (!Boolean(plat)) {
        this.formMenu.data = this.menusList[0].plat
      } else {
        this.formMenu.data = plat * 1
      }
    }
  },
  mounted() {
    this.checkUserIsAdmin()
    this.queryDeadDateBySellerId()
    this.verifyPlat()
  },
  watch: {
    formMenu: {
      handler(val, oldval) {
        if (val.data !== oldval.data) {
          this.$router.go(0);
        }
      },

    },
    $route: {
      handler(val, oldval) {
        // console.log(val, '新值')
        // console.log(oldval, '老值')
        // if(oldval.name!==val.name){
        //     if(val.name==='jdHomeIndexOverview' || val.name==='homeIndexOverview'){
        //         this.$router.go(0);
        //     }
        // }
        // this.queryDeadDateBySellerId()

      },
      // // 深度观察监听
      deep: true
    }
  }

}



// WEBPACK FOOTER //
// ./src/layout/headerNav/headerNav.js